import React from 'react';

import { Tooltip, Typography } from 'antd';

import ActionCollapse from 'v2/components/Shared/QuickView/ActionCollapse';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import { dateService } from 'v2/services/date';

import { getStatusColor } from '../statusColors';

const InvoiceDetails = ({ delivery }: { delivery: ShoppingDelivery }) => {
  return (
    <ActionCollapse title={`Dados da fatura (${delivery.invoice_id})`} defaultOpen>
      <div className='flex flex-col gap-2'>
        <div className='grid grid-cols-3 gap-2'>
          <Typography.Text strong>Emissão</Typography.Text>
          <Typography.Text strong>Pag.</Typography.Text>
          <Typography.Text strong className='block text-right'>
            Valor
          </Typography.Text>
        </div>

        <div className='flex items-stretch gap-2'>
          <Tooltip title={delivery.payment_status.name} placement='top'>
            <span className={`w-1 shrink-0 self-stretch rounded ${getStatusColor(delivery.payment_status.alias)}`} />
          </Tooltip>
          <div className='grid flex-1 grid-cols-3 gap-2 rounded-(--uizz-antd-border-radius) bg-(--uizz-antd-color-fill-tertiary) p-2'>
            <Typography.Text>
              {delivery.created_at ? dateService.dateToString(new Date(delivery.created_at), 'dd/MM/yyyy') : '-'}
            </Typography.Text>
            <Typography.Text>
              {delivery.received_at ? dateService.dateToString(new Date(delivery.received_at), 'dd/MM/yyyy') : '-'}
            </Typography.Text>
            <Typography.Text className='block text-right'>
              {delivery.total_value.toLocaleString('pt-BR', {
                style: 'currency',
                currency: delivery.currency_code
              })}
            </Typography.Text>
          </div>
        </div>
      </div>
    </ActionCollapse>
  );
};

export default InvoiceDetails;
